<template>
    <div class='navigator__item'>
        <div class="navigator__ico">
            <switcher :classSwitcher="status" @switchStatus = "switchCange($event)"/>
        </div>
        <div class="navigator__text">
            {{item}}
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { ContainerMixin, ElementMixin } from 'vue-slicksort';
import Switcher from './switcher'
export default {
    mixins: [ElementMixin],
    props: ['item','status'],
    components: {
        'switcher':Switcher
    },
    methods: {
        switchCange(e) {
            this.$emit('changeSwitch', e);
        }
    }
}
</script>
<style lang="less" scoped>
.navigator {
    &__item {
        border-top: 1px solid #465f7a;
        cursor: pointer;
        overflow: hidden;
        display: flex;
        align-items: center;
        max-height: 40px;
        color:#fff;
        z-index: 3;
    }
    &__text {
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.64;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: #ffffff;
        margin-left: 15px;
    }

    &__ico {
        
        padding-right: 3px;
        text-align: center;
        margin-left: 15px;
    }
}
</style>
